import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

import * as _ from 'lodash';

@Injectable()
export class MachineryService {

    MACHINERY_BACKENDURL: string;
    token: string;

    constructor(
        private appConfigService: AppConfigService,
        private authService: AuthService,
        private http: HttpClient
    ) {
        this.MACHINERY_BACKENDURL = this.appConfigService.config.machineryBackendUrl;
        this.token = this.authService.accessToken;
    }

    getPartInfo(partNumber) {
        console.log('getPart()', partNumber);
        return this.http.get(`${this.MACHINERY_BACKENDURL}/parts/${partNumber}`, { headers: this._getHeaders() });
    }

    getCustomerInfo(company, partnerId): Observable<ICustomerInfo>  {
        console.log('getCustomerInfo()', company, partnerId);
        return this.http.get(`${this.MACHINERY_BACKENDURL}/customers/company/${company}/partner/${partnerId}`, { headers: this._getHeaders() }) as Observable<ICustomerInfo>;
    }

    searchCustomers(params) {
        console.log('searchCustomers', params);
        return this.http.get(`${this.MACHINERY_BACKENDURL}/customers${this._getSearchString(params)}`, { headers: this._getHeaders() });
    }

    _getHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.token}`
        });
    }

    // Returns search params ?search=key:value;key2:value2
    _getSearchString(params) {
        const queryStringParams = _.map(params, (p) => {
            return p.key + ':' + p.value;
        }).join(',');
        if (queryStringParams) {
            return `?search=${encodeURIComponent(queryStringParams)}`;
        } else {
            return '';
        }
    }

}

export interface ICustomerInfo {
    id: string;
    company: string;
    custId: string;
    name: string;
    country: string;
    groupCode: string;
    groupDesc: string;
    currencyCode: string;
    langNameId: string;
    address?: {
        address?: string;
        address1?: string;
        address2?: string;
        address3?: string;
        zip?: string;
        city?: string;
        state?: string;
        country?: string;
    };
}
